import {
    Injectable,
    Injector,
    inject,
} from "@angular/core";

import { EntityName } from "./entity.model";

import {
    ConfigurationManagerService,
    EntityManagerService
} from "src/app/core";

@Injectable({
    providedIn: 'root'
})
export class StartupQueriesService {
    private injector = inject(Injector);

    /**
     * Retrieves the startup query for the provided entity name.
     *
     * @param {EntityName} entityName - The name of the entity.
     * @return {object} The startup query object.
     */
    public getStartupQuery(entityName: EntityName | keyof EntityManagerService) {
        switch (entityName) {
            case 'bookings': {
                const configurationManager = this.injector.get(ConfigurationManagerService);

                if(!configurationManager.isModuleAngular('bookings')) {
                    return;
                }

                //Return range from the start of the week (use Sunday to be sure) to 31 days in the future
                const startDate = new Date();
                startDate.setHours(0, 0, 0, 0);

                const endDate = new Date(startDate);
                endDate.setDate(startDate.getDate() + 31);

                return  {
                    booked_for_since: startDate.toISOString(),
                    booked_for_max: endDate.toISOString()
                };
            }
            case 'items': {
                return { on_sale: true };
            }
            case 'sales': {
                return { status: 'open' };
            }
            case 'sale_transactions': case 'saleTransactions': {
                return { 'sale.status': 'open' };
            }
            case 'stock': {
                return { item_on_sale: true };
            }
            default: {
                return {};
            }
        }
    }

    /**
     * Retrieves the default pagination information.
     *
     * @param {EntityName} entityName - The name of the entity.
     * @return {object} The pagination information for the entity.
     */
    public getPaginationInfo(entityName: EntityName | keyof EntityManagerService) {
        switch (entityName) {
            case 'items':
                return 10000;
            case 'customers':
                return 5000;
            case 'stock':
                return 10000;
            default:
                break;
        }
    }
}